<div class="flex-row padding-30">
  <div class="flex-1"></div>

  <div class="flex-3">
    <div class="flex-1 flex-row">
      <mat-form-field appearance="outline">
        <mat-label>New Service</mat-label>
        <input matInput type="text" autocomplete="false" [(ngModel)]="newServiceTypeName">
        @if (newServiceTypeName) {
          <button  mat-button matSuffix mat-icon-button aria-label="Clear" (click)="newServiceTypeName=''">
            <mat-icon>close</mat-icon>
          </button>
        }
      </mat-form-field>

      <div class="margin-left-30 flex-column">
        @if (!loading) {
          <button mat-flat-button
            style="border-radius: 4px;"
            color="primary"
            (click)="addServiceType()"
            class="span-form margin-tb-10 shade">
            <span style="vertical-align: bottom;">+&nbsp;&nbsp;</span> Add Service
          </button>
        }
      </div>
      <div class="ml-2 align-items-center flex-row">
        @if (loading) {
          <mat-spinner [diameter]="70"></mat-spinner>
        }
        @if (serviceTypeInvalid) {
          <p class="invalid-service">Invalid Service Type</p>
        }
        @if (duplicateServiceType) {
          <p class="invalid-service">Duplicate Service Type</p>
        }
        @if (successAdd) {
          <p class="valid-service">Service Type Added</p>
        }
      </div>
    </div>




    <h3 class="large-text">Service Types</h3>

    @if (loading) {
      <mat-progress-bar style="height: 5px; width: 100%;" mode="indeterminate"></mat-progress-bar>
    }
    <div class="shade">
      <div class="scrollable-table">
        <table mat-table [dataSource]="serviceTypes" class="mat-elevation-z8">
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>Name</th>
            <td mat-cell *matCellDef="let element">{{element.name}}</td>
          </ng-container>

          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef>Status</th>
            <td mat-cell *matCellDef="let element">{{element.serviceTypeStatus}}</td>
          </ng-container>

          <ng-container matColumnDef="dateModified">
            <th mat-header-cell *matHeaderCellDef>Date Updated</th>
            <td mat-cell *matCellDef="let element">{{element.updateDateUTC | date:'shortDate'}}</td>
          </ng-container>

          <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef>
              <button mat-icon-button
                [disabled]="loading"
                (click)="getAllServiceTypes()"
                class="span-form margin-tb-10 float-right">
                <mat-icon>refresh</mat-icon>
              </button>
            </th>
            <td mat-cell *matCellDef="let element">
              @if (element.serviceTypeStatus == 'ACTIVE') {
                <button
                  mat-icon-button
                  [disabled]="loading"
                  (click)="toggleServiceType(element.serviceTypeId, true)"
                  class="span-form margin-tb-10 float-right">
                  <mat-icon>delete</mat-icon>
                </button>
              }

              @if (element.serviceTypeStatus == 'INACTIVE') {
                <button
                  mat-icon-button
                  [disabled]="loading"
                  (click)="toggleServiceType(element.serviceTypeId, false)"
                  class="span-form margin-tb-10 float-right">
                  <mat-icon>delete</mat-icon>
                </button>
              }
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="serviceTypeColumnHeaders"></tr>
          <tr mat-row *matRowDef="let row; columns: serviceTypeColumnHeaders;"></tr>

          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" colspan="4">No services found.</td>
          </tr>
        </table>
      </div>
    </div>
  </div>

  <div class="flex-1"></div>
</div>

